import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {GameInfo} from '../../../../services/games/game-info';
import {Check} from '@sparkware/app-utils';
import {observer} from 'mobx-react';
import {IModalDialogHandler} from '../../../../services/dialog/dialog.service.interface';
import {GameInfoButtonBox} from './boxes/game-info-button/game-info-button.box';
import {DialogTitleBox} from '../../../modal-dialog/boxes/title/dialog-title.box';
import {DialogCloseButtonBox} from '../../../modal-dialog/boxes/close-button/dialog-close-button.box';
import {Image} from '../../../raw-components/image/image';
import {DialogHeaderComponent} from '../../../modal-dialog/parts/header/dialog-header.component';

export interface MobileGamePreviewTitleComponentProps {
  gameInfo: GameInfo;
  arenaName?: string;
  dialogHandler: IModalDialogHandler;
}

export const TitleComponent = observer(
    class TitleComponent extends OrbitComponent<MobileGamePreviewTitleComponentProps> {

        _openGameInfo = () => {
            const gameInfo = this.props.gameInfo;
            this._closeInfoMobile();

            if (this.props.arenaName) {
                //TODO: Do we need it?
                this.services.analytics.sendElasticInfoEvent({eventType:"CGP_Game_Click",category: this.props.arenaName, action: "Open_Game_Info", label: `SEO_${gameInfo.gameType}`}, true);
            }

            this.services.location.push(gameInfo.infoPageURL);
        };

        _closeInfoMobile = () => {
            this.props.dialogHandler?.close();
        };

        private _renderOpenInfoButton(gameInfo: GameInfo) {

            if (Check.isEmpty(gameInfo.infoPageURL) || this.services.miniOrbit.isEnabled) {
                return null;
            }

            return (
                <GameInfoButtonBox className='cy-game-info-button' onClick={this._openGameInfo}>
                    <Image src={this.services.theme.currentTheme.images.intermediatePageGameInfoButton.toString()}/>
                </GameInfoButtonBox>
            );
        }

        render() {
            let gameInfo = this.props.gameInfo;
            return (
                <DialogHeaderComponent>
                    <DialogTitleBox className='cy-intermediate-page-title'>{gameInfo.title}</DialogTitleBox>
                    {this._renderOpenInfoButton(gameInfo)}
                    <DialogCloseButtonBox className='cy-close-button' onClick={this._closeInfoMobile}/>
                </DialogHeaderComponent>
            );
        }
    }
);


